import { DictionaryRecordDto } from '@lmt/shared-types';
import clsx from 'clsx';
import React, { useCallback } from 'react';
import { Trans } from 'react-i18next';

import styles from './TagsViewer.module.scss';
import { useTags } from './useTags';

interface Props {
  text: string;
  onTagClick?: (tag: DictionaryRecordDto) => void;
  className?: string;
  testId?: string;
}

function parseTags(value: string): string {
  if (value === null || value === undefined || value === '') {
    return '';
  }
  if (typeof value !== 'string') {
    return value;
  }
  const keys = value.toString().match(/\[(.+?)\]\{(.+?)\}/);
  if (keys === null) {
    return value;
  }
  const updatedValue = value.replace(keys[0], `<span>${keys[1]}</span>`);
  return parseTags(updatedValue);
}

export const TagsViewer: React.FC<Props> = (props) => {
  const { text, onTagClick, className } = props;
  const tags = useTags();

  const onClick = useCallback((value: string) => {
    const tag = tags.find((tag) => tag.value === value.substring(1));
    if (!tag || tag.isDeleted) {
      return;
    }
    if (!!onTagClick) {
      onTagClick(tag);
    } else {
      // ToDo: search
    }
  }, []);

  const parsedTags = parseTags(text);

  return (
    <div className={clsx(className, styles.text)} data-test-id={props.testId}>
      {text === undefined || text === null || text === '' ? (
        '-'
      ) : // #55577: parsedTags actually may have other type (e.g. Number), we need to check type additionally
      typeof (parsedTags as any) === 'string' &&
        !parsedTags.includes('<span>') &&
        !parsedTags.includes('<b>') ? (
        parsedTags
      ) : (
        <Trans
          defaults="{{parsedTags}}"
          values={{ parsedTags: parsedTags }}
          components={{
            b: <b />,
            p: <p />,
            // a: <a />,
            span: (
              <span
                className={styles.tag}
                onClick={(e) => onClick(e.currentTarget.innerText)}
              />
            ),
          }}
        >
          {parsedTags}
        </Trans>
      )}
    </div>
  );
};
